import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { browserHistory } from '@client/router/compat';
import LogoSvg from '../../assets/logo.svg?react';
import { Typography } from '@mui/material';

export const AuthLayout = ({
  showGoBack,
  title,
  children,
}: {
  showGoBack?: boolean;
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-50 md:p-12">
      {showGoBack && (
        <div
          className="relative w-full flex justify-center cursor-pointer items-center max-w-lg md:max-w-none mt-8 md:mt-12 md:mb-20"
          onClick={() => browserHistory.goBack()}
        >
          <div className="absolute left-0 bg-white p-3 rounded-xl border border-gray-200 ml-4">
            <FontAwesomeIcon
              icon={faArrowLeft as any}
              className="w-auto h-3 md:h-5 flex-no-shrink fill-current"
            />
          </div>
          <LogoSvg className="w-auto h-5 flex-no-shrink fill-current" />
        </div>
      )}
      <div className="w-full min-h-screen max-w-lg md:max-w- flex flex-col items-center px-6 lg:px-12 text-center ">
        <div className="w-full flex flex-col">
          <div className="mt-8 font-bold text-center text-gray-900">
            <Typography variant="h3">{title}</Typography>
          </div>
        </div>

        <div className="flex-1 w-full max-w-[416px] flex flex-col items-center justify-between">
          {children}
        </div>
      </div>
    </div>
  );
};
